module.exports = __webpack_public_path__ + "static/Dark-Red-36fd92c231bdfa47611367823acebafd.png";